import { render, staticRenderFns } from "./aiCallCom.vue?vue&type=template&id=9efcc7d4"
import script from "./aiCallCom.vue?vue&type=script&lang=js"
export * from "./aiCallCom.vue?vue&type=script&lang=js"
import style0 from "./aiCallCom.vue?vue&type=style&index=0&id=9efcc7d4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9efcc7d4')) {
      api.createRecord('9efcc7d4', component.options)
    } else {
      api.reload('9efcc7d4', component.options)
    }
    module.hot.accept("./aiCallCom.vue?vue&type=template&id=9efcc7d4", function () {
      api.rerender('9efcc7d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/logCom/aiCallCom.vue"
export default component.exports